var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
var AuthImage = function (_a) {
    var filename = _a.filename, fallbackSrc = _a.fallbackSrc, _b = _a.alt, alt = _b === void 0 ? '' : _b, imgProps = __rest(_a, ["filename", "fallbackSrc", "alt"]);
    var _c = useState(false), failed = _c[0], setFailed = _c[1];
    var name = (filename || '').trim();
    // Reset the error state whenever the target file changes.
    useEffect(function () {
        setFailed(false);
    }, [name]);
    var src = !name || failed ? fallbackSrc : "/api/files/".concat(encodeURIComponent(name));
    if (!src) {
        return null;
    }
    return _jsx("img", __assign({ src: src, alt: alt, onError: function () { return setFailed(true); } }, imgProps));
};
export default AuthImage;
